import { companyNow } from '../../utils/format'
import { ymd } from '../sales/salesShared'

// Helpers shared by the Expenses pages.

/** Where an expense came from, in plain words. */
export const KIND_LABEL = {
  entered: 'Recorded here',
  journal: 'Journal entry',
  auto: 'Automatic',
}

/** Spending people chose to make (not depreciation, stock losses and the like). */
export const isSpending = (row) => row.kind !== 'auto'

/** Account choices as <optgroup>s, in chart order: [[group, [{code, name}]]]. */
export const groupAccounts = (accounts = []) => {
  const groups = new Map()
  accounts.forEach((a) => groups.set(a.group, [...(groups.get(a.group) || []), a]))
  return [...groups]
}

export const PERIODS = [
  { id: 'month', label: 'This month' },
  { id: 'last-month', label: 'Last month' },
  { id: 'year', label: 'This year' },
  { id: 'last-year', label: 'Last year' },
  { id: 'all', label: 'All time' },
]

/** [start, end] for a period, as YYYY-MM-DD on the company's clock ('' for
    open-ended). This month and this year run to their last day, so anything
    dated later in them still shows. */
export function periodRange(id, today = companyNow()) {
  const y = today.getFullYear()
  const m = today.getMonth()
  if (id === 'month') return [ymd(new Date(y, m, 1)), ymd(new Date(y, m + 1, 0))]
  if (id === 'last-month') return [ymd(new Date(y, m - 1, 1)), ymd(new Date(y, m, 0))]
  if (id === 'year') return [ymd(new Date(y, 0, 1)), ymd(new Date(y, 11, 31))]
  if (id === 'last-year') return [ymd(new Date(y - 1, 0, 1)), ymd(new Date(y - 1, 11, 31))]
  return ['', '']
}

/** Total of a list of expenses. */
export const total = (rows) => rows.reduce((s, r) => s + Number(r.amount || 0), 0)
